import React, { ReactNode } from 'react';
import { DialogOverlay, DialogContent, DialogHeader, DialogBody, DialogProvider, DialogPortal, DialogFooter } from './';

interface DialogProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: ReactNode;
  headlineSize?: number;
}

const Dialog = ({ isOpen, onClose, title, children, headlineSize = 20 }: DialogProps) => {
  if (!isOpen) return null;

  return (
    <DialogProvider isOpen={isOpen} onClose={onClose}>
      {isOpen && (
        <>
          {DialogPortal({
            children: (
              <DialogOverlay>
                <DialogContent>
                  <DialogHeader title={title} headlineSize={headlineSize} onClose={onClose} />
                  <DialogBody>{children}</DialogBody>
                  <DialogFooter onClose={onClose} />
                </DialogContent>
              </DialogOverlay>
            ),
          })}
        </>
      )}
    </DialogProvider>
  );
};

export default Dialog;
